import { handleApiCall } from "./Interactor"


export const getTransactionList = (page, query, filter, date, end_date, onSuccessView, onFailedView) => {

  if (end_date === "") {
    end_date = date
  }

  let param = {
    "page": page,
    "search": query,
    "filter": filter,
    "sort_by": "booking_date",
    "sort_direction": "asc",
    "start_date": date,
    "end_date": end_date
  }

  handleApiCall(
    "POST",
    process.env.REACT_APP_TRANSACTION_LIST, param,
    (responseJSON) => {
      // console.log("result post ", responseJSON)
    },
    onSuccessView,
    onFailedView
  )

}
export const exportTransactionList = (page, query, filter, date, end_date, onSuccessView, onFailedView) => {

  let param = {
    "page": page,
    "search": query,
    "filter": filter,
    "sort_by": "booking_date",
    "sort_direction": "asc",
    "start_date": date,
    "end_date": end_date
  }

  handleApiCall(
    "GET",
    process.env.REACT_APP_TRANSACTION_EXPORT, param,
    (responseJSON) => {
      // console.log("result post ", responseJSON)
    },
    onSuccessView,
    onFailedView
  )

}


export const getTransactionDetail = (transactionId, onSuccessView, onFailedView) => {

  handleApiCall(
    "GET",
    process.env.REACT_APP_TRANSACTION_DETAIL + "/" + transactionId + "/detail", {},
    (responseJSON) => {
      // console.log("result post ", responseJSON)
    },
    onSuccessView,
    onFailedView
  )

}